// extracted by mini-css-extract-plugin
export default {"actionIcons":"AssignAccountGroup_actionIcons__OXf+e"};